/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddressList from '@/pages/repairManagement/AddressList.vue';
import { apiAddressList, postDetermineOrder, getContacts, getObjPropFind } from '@/api';
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import SmyMapAddress from '@/components/CustomFormList/SmyMapAddress';
import SingleVantPicker from './SingleVantPicker';
import SinglePicker from '@/components/Base/SinglePicker';
import { mapState } from 'vuex';
import Big from 'big.js';
export default {
  name: 'determineOrder',
  components: {
    SinglePicker: SinglePicker,
    Group: Group,
    SmyMapAddress: SmyMapAddress,
    AddressList: AddressList,
    SingleVantPicker: SingleVantPicker
  },
  data: function data() {
    return {
      settlementProduct: [],
      chosenAddressId: 1,
      address: {
        gps_addr: ''
      },
      from: {
        fk_t_ep_home_children_account_address_id: '',
        //地址id
        receiving_address: '',
        //收货地址
        customer_name: '',
        //客户名称
        linkperson: '',
        //联系人名称
        linkperson_phone: '',
        //联系人电话
        invoice_mailing_address: '',
        //发票地址
        shopInfo: [],
        //商品
        pay_method: 1,
        //支付方式
        invoice_title: '',
        //发票抬头
        create_remark: '',
        //备注
        detail_address: '',
        //发票邮寄详细地址
        totle_amount: '',
        //总价
        fk_t_customer_id: ''
      },
      showArea: false,
      showPicker: false,
      columns: [{
        text: i18n.tc("161"),
        value: 1
      }],
      isAddressListShow: false
    };
  },
  methods: {
    onConfirm: function onConfirm(value) {
      this.from.pay_method = value;
      this.showPicker = false;
    },
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiAddressList();
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this.address = res.data.find(function (item) {
                    return item.is_default === 1;
                  }) || {};
                } else {
                  _this.$vux.toast.text(res.message);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    AddressClick: function AddressClick(e) {
      this.address.id = e.id;
      this.address.gps_addr = e.gps_addr;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      if (!this.address.id) return this.$vux.toast.text(i18n.tc("298"));
      var formDatta = _objectSpread({}, this.from);
      var arr = this.settlementProduct.map(function (v) {
        var obj = {
          fk_t_shop_goods_id: v.fk_t_shop_goods_id,
          goods_num: v.add_munber
        };
        return obj;
      });
      formDatta.fk_t_ep_home_children_account_address_id = this.address.id;
      formDatta.receiving_address = this.address.gps_addr;
      formDatta.shopInfo = arr;
      formDatta.totle_amount = this.sumPrice;
      postDetermineOrder(formDatta).then(function (res) {
        if (res.success) {
          if (+_this2.from.pay_method === 1) {
            _this2.$router.push({
              name: 'offline',
              params: {
                id: res.data.fk_t_shop_order_id,
                price: _this2.from.totle_amount || _this2.sumPrice
              }
            });
          } else {
            _this2.$router.push({
              name: 'orderDetails',
              params: {
                id: res.data.fk_t_shop_order_id
              }
            });
          }
        } else {
          _this2.$vux.toast.text(i18n.tc("634"));
        }
      });
    },
    selectAddress: function selectAddress(data) {
      var type = data.type,
        name = data.name,
        address = data.address,
        latitude = data.latitude,
        longitude = data.longitude,
        code = data.code;
      this.address_type = type;
      if (data.type == 2) {
        this.from.invoice_mailing_address = name.join();
        var _code = _slicedToArray(code, 4),
          prov_id = _code[0],
          city_id = _code[1],
          district_id = _code[2],
          street_id = _code[3];
        this.from.prov_id = prov_id;
        this.from.city_id = city_id;
        this.from.district_id = district_id;
        this.from.street_id = street_id;
      } else {
        this.from.invoice_mailing_address = address;
        this.from.gps_addr = address;
        this.from.map_name = address;
        this.from.latitude = latitude;
        this.from.longitude = longitude;
      }
    },
    getCont: function getCont() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getContacts();
              case 2:
                res = _context2.sent;
                if (res.success && res.data) {
                  _this3.from.linkperson = res.data.linkperson;
                  _this3.from.linkperson_phone = res.data.linkperson_phone;
                  _this3.from.fk_t_customer_id = res.data.fk_t_customer_id;
                  _this3.from.customer_name = res.data.customer_name;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    sumPrice: function sumPrice() {
      var sum = 0;
      this.settlementProduct.map(function (val) {
        sum += Number(new Big(val.add_munber).mul(val.price));
      });
      return sum;
    }
  }),
  created: function created() {
    var _this4 = this;
    this.settlementProduct = JSON.parse(localStorage.getItem('arrOrder')) || [];
    this.getList();
    this.getCont();
    getObjPropFind({
      prop_code: 990001,
      ob_id: this.user.epId,
      obj_type: 99
    }).then(function (res) {
      if (res.success) {
        var bol = Number(res.data.prop_value);
        if (bol) {
          _this4.columns = _this4.columns.concat({
            text: i18n.tc("249"),
            value: 2
          });
          _this4.from.pay_method = '2';
        }
      }
    });
  },
  mounted: function mounted() {
    if (sessionStorage.getItem('name') == 'shop') {
      this.isAddressListShow = true;
      sessionStorage.removeItem('name');
    }
  }
};